export default "__VITE_ASSET__CZQT3wPv__"